const adminPanel = {
  adminPanel: {
    einAdmin: 'EIN Administrator',
    einInstallerSetup: 'EIN Installateur Konfiguration',
    installerDataUpdate: 'Installateur-Datenaktualisierung',
    uploadFile: 'Datei hochladen',
    chooseFile: 'Datei auswählen',
    installerDataUpdateDescription: 'Enphase Installer-Marktanteil, Informationen über Executive Sponsoren usw.',
    header: 'Links in der Kopfleiste',
    platinumTier: 'Platin-Level',
    goldTier: 'Gold-Level',
    silverTier: 'Silber-Level',
    same: 'Für alle Level gleich',
    bannerDescription: 'Banner-Beschreibung',
    bannerLink: 'Banner-Link',
    digitalAssets: 'Digitale Ressourcen',
    name: 'Name',
    file: 'Datei',
    access: 'Zugriff auf die Level-Kategorie',
    action: 'Aktion',
    all: 'Alle',
    platinum: 'Platin',
    gold: 'Gold',
    silver: 'Silber',
    addDigital: 'Digitale Ressourcen hinzufügen',
    productInformation: 'Produktinformationen',
    productName: 'Produktbezeichnung',
    learnMoreLink: 'Link „Mehr erfahren“',
    featureName: 'A/B-Funktionsbezeichnung',
    featureType: 'Funktionstyp',
    betaRelease: 'Datum der Beta-Ausgabe',
    addProduct: 'Produktinformationen hinzufügen',
    exclusiveUpdate: 'Exklusive Aktualisierungslinks',
    description: 'Beschreibung',
    link: 'Link',
    addLink: 'Link hinzufügen',
    one: '1.',
    two: '2.',
    installerList: 'Installateurverzeichnis für Produktzugriff',
    usa: 'USA',
    // TODO - Start
    usa_pr: 'USA - Puerto Rico',
    france: 'France',
    // TODO - End
    australia: 'Australien',
    belgium: 'Belgien',
    netherlands: 'Niederlande',
    germany: 'Deutschland',
    india: 'Indien',
    mexico: 'Mexiko',
    country: 'Land',
    fileName: 'Dateiname',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUKT',
    empty_file: 'Datei ist leer',
    invalidFileFormat: 'Ungültiges Dateiformat',
    invalidFileHeader: 'Ungültiger Dateikopf',
    uploadFailed: 'Hochladen der Datei fehlgeschlagen',
    invalidFile: 'Ungültige Datei',
    errorDetail: {
      one: '%{errorCount} von %{count} Zeile fehlgeschlagen.',
      other: '%{errorCount} von %{count} Zeilen fehlgeschlagen.'
    },
    viewError: 'Fehler anzeigen',
    errorListText: 'Datei-Upload-Fehlerliste',
    companyId: 'Firmen-ID',
    message: 'Nachricht',
    sampleFileName: 'Musterdatei'
  }
};

export default adminPanel;
